module.exports = __webpack_public_path__ + "img/54.6.CODm.b07f1ec0.png";